import { z } from "zod"

import { monthlyFormSchema } from "../validation"

/**
 * Result summary (without intervals array to save storage space)
 */
const monthlyResultSummarySchema = z.object({
  agentsFte: z.number(),
  agentsPer30MinsMax: z.number(),
  callsPer30MinsMax: z.number(),
  callsPerWeek: z.number(),
})

export type MonthlyResultSummary = z.infer<typeof monthlyResultSummarySchema>

/**
 * Persisted calculation structure for monthly calculator
 */
export const monthlySavedCalculationSchema = z.object({
  version: z.literal(1),
  formValues: monthlyFormSchema,
  result: monthlyResultSummarySchema.nullable(),
  advancedOpen: z.boolean(),
  status: z.enum(["idle", "complete"]),
})

export type MonthlySavedCalculation = z.infer<typeof monthlySavedCalculationSchema>

export const MONTHLY_STORAGE_KEY = "erlang-calculator:monthly:last-calculation"
